<template>
  <span>
    <colored-icon v-if="options.showIcon" :color="color" :icon-class="iconClass" :shadow="false"></colored-icon
    >&nbsp;<span v-if="options.showText">{{ value }}</span>
  </span>
</template>

<script>
import ColoredIcon from '@kanrisha/components/Icons/ColoredIcon';

export default {
  components: {
    ColoredIcon,
  },
  props: {
    color: { type: String, default: '' },
    iconClass: { type: String, default: 'bi bi-circle-fill' },
    value: { type: String, default: null },
    options: {
      type: Object,
      default: () => ({
        showText: true,
        showIcon: true,
      }),
    },
  },
  setup() {
    return {};
  },
};
</script>
